import { render } from "./BuddySelectButton.vue?vue&type=template&id=8b71069c&scoped=true"
import script from "./BuddySelectButton.vue?vue&type=script&lang=js"
export * from "./BuddySelectButton.vue?vue&type=script&lang=js"

import "./BuddySelectButton.vue?vue&type=style&index=0&id=8b71069c&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b71069c"]])

export default __exports__